export default "__VITE_ASSET__aBbCGFXA__"